<template lang="pug">
  .wrapper-groups-details
    template(slot="heading")
      span.fs-19(style="text-align: center;") {{ id ? 'editar' : 'novo' }}

    template
      .form-new
        Validate.name(v-model="name" v-if="!processing")
          PTextField(
            name="name"
            v-focus
            label="nome do usuário"
          )

        SkeletonBox.name(v-else key="loadingStatus" width="100%" height="30px")

        Validate.email(v-model="email" :required="false" :customError="validEmail" v-if="!processing")
          PTextField(name="email" label="email")

        SkeletonBox.email(margin="30px 0 0 0" v-else key="loadingStatus" width="100%" height="30px")

        Validate.permissions(v-model="permissions" v-if="!processing")
          PSelect(
            labelItem="name"
            required
            title="permissões no sistema"
            :allowEmpty="false"
          )

        SkeletonBox.permissios(v-else key="loadingStatus" width="100%" height="30px")

        Validate.pg(v-model="pg" v-if="!processing")
          PSelect(
            labelItem="name"
            required
            title="permissões no PontoTel Gestão"
            :allowEmpty="false"
          )
        SkeletonBox.pg(margin="30px 0 0 0" v-else key="loadingStatus" width="100%" height="30px")

        div.password(v-if="!processing")
          PTextField(
            v-if="showPasswordField"
            v-model="password"
            name="password"
            autocomplete="new-password"
            :label="`senha de acesso ao sistema ${id ? '(manter vazio caso não queira alterar)' : ''}`"
            type="password"
          )

        SkeletonBox.password(margin="30px 0 0 0" v-else key="loadingStatus" width="100%" height="30px")

        div.codigo(v-if="!processing")
          PTextField(
            v-model="codigo"
            name="codigo"
            autocomplete="new-codigo"
            label="Código"
            type="codigo"
            placeholder="Um código especial de identificação do usuário na organização"
          )

        SkeletonBox.codigo(margin="30px 0 0 0" v-else key="loadingStatus" width="100%" height="30px")

        div.items-slider(v-if="!processing")
          RadioSlider(
            v-if="permissions.selected && permissions.selected.kind !== 'all' && permissions.selected.kind !== 'mine'"
            :items="categories.items",
            :current="categories.items.findIndex(i => i.id === categories.selected.id)",
            @selected="openItemsSelector"
          )

        SkeletonBox.items-slider(margin="30px 0 0 0" v-else key="loadingStatus" width="100%" height="30px")

        div.items-selector(v-if="!processing")
          PMultiSelect(
            v-if="permissions.selected && permissions.selected.kind !== 'all' && permissions.selected.kind !== 'mine'"
            ref="itemSelector"
            labelItem="name"
            :title="categorieSelected.name"
            v-model="$data[categorieSelected.state]"
            :useCommon="categorieSelected.common"
            :disabled="!categories.selected"
          )

        SkeletonBox.items-selector(margin="30px 0 0 0" v-else key="loadingStatus" width="100%" height="30px")

        .button
          PButton(color="success" size="md" @click="save" :loading="loading") salvar
          PButton(color="danger" size="md" @click="$emit('close')") cancelar

</template>

<script>
import { mask } from 'vue-the-mask'
import RadioSlider from 'src/common/Tabs/RadioSlider'
import { useValidationsMixin } from 'src/common/validations'

export default {
  name: 'UserDetails',
  props: {
    id: { default: null },
    employeeId: { default: null }
  },
  data () {
    return {
      user: {},
      name: '',
      email: '',
      password: '',
      codigo: '',
      loading: false,
      processing: true,
      companies: { selected: null },
      userGroups: { selected: null },
      roleGroup: null,
      categories: {
        selected: null,
        items: [
          { name: this.$wp('companyShortName'), id: 'company', common: 'companies/onlyActive', state: 'companies' },
          { name: 'grupos', id: 'userGroup', common: 'userGroups', state: 'userGroups' }
        ]
      },
      permissions: { selected: null, loaded: [] },
      pg: { selected: null, loaded: [] },
      isFromEmployee: false,
      companyFromEmployee: null,
      employee: null
    }
  },
  async created () {
    if (!this.id) this.processing = false

    this.employee = await this.getEmployeeInfo(this.employeeId)
    if (this.employee) {
      this.isFromEmployee = true
      this.companyFromEmployee = this.employee.company[0]
      this.name = this.employee.name
      this.email = this.employee.email
    }

    this.categories.selected = this.categories.items[0]
    try {
      const result = await this.$API.roleGroup.get()
      let roleGroups = result.body.success
      if (!this.id && !this.isFromEmployee) {
        roleGroups = roleGroups.filter(r => r.kind !== 'mine')
      }
      if (this.ocultarRhDosSelects) {
        roleGroups = roleGroups.filter(r => r.kind !== 'all')
      }

      this.permissions.loaded = roleGroups
      this.permissions.selected = roleGroups[0]

      this.pg.loaded = [
        {id: 'same', name: '-- Utilizar a mesma permissão do sistema (definida acima) --'},
        ...roleGroups
      ]
      this.pg.selected = this.pg.loaded[0]
    } catch (e) {
      const msg = e.data.error || 'Aconteceu um erro. Tente novamente.'
      this.$swal({
        type: 'error',
        title: 'Atenção',
        text: msg
      })
      this.$emit('close')
    }

    if (this.id) {
      try {
        const result = await this.$API.user.get({ id: this.id })
        this.user = result.body.success[0]

        if (this.user.compemployee.length === 0) {
          this.permissions.loaded = this.permissions.loaded.filter(p => p.kind !== 'mine')
          this.pg.loaded = this.pg.loaded.filter(p => p.kind !== 'mine')
        }

        if (this.user.group.length !== 0) {
          this.categories.selected = this.categories.items[0]
        } else {
          this.categories.selected = this.categories.items[1]
        }

        this.name = this.user.name
        this.email = this.user.email
        this.companies.selected = this.user.group
        this.userGroups.selected = this.user.userGroup
        this.permissions.selected = this.user.roleGroup
        this.codigo = this.user.codigo || ''
        if (this.user.appGestorRoleGroup) this.pg.selected = this.user.appGestorRoleGroup

        this.processing = false
      } catch (e) {
        console.log(e)
        const msg = e.data.error || 'Aconteceu um erro. Tente novamente.'
        this.$swal({
          type: 'error',
          title: 'Atenção',
          text: msg
        })
        this.$emit('close')
      }
    }
  },
  computed: {
    ocultarRhDosSelects () {
      const idDaCompManLogada = this.$store.state.userInfo.compMan.id
      const idsCompMansParaOcultar = {
        atento: '5dc02085dc99a6000ddf2bf2'
      }
      return Object.values(idsCompMansParaOcultar).includes(idDaCompManLogada)
    },
    categorieSelected () {
      if (this.categories.selected) return this.categories.selected

      return {
        name: 'Selecionar',
        id: 'company',
        common: 'companies/onlyActive',
        state: 'companies'
      }
    },
    validEmail () {
      return this.email && /\S+@\S+/.exec(this.email) ? '' : 'email inválido'
    },
    forcedPlaceholder () {
      const companies = this.companies.selected || []
      const userGroups = this.userGroups.selected || []

      if (companies.length || userGroups.length) {
        return null
      }

      if (this.categories.selected.id === 'company') {
        return 'selecionar ' + this.$wp('company')
      } else {
        return 'selecionar grupos'
      }
    },
    showPasswordField () {
      return !this.$store.state.userInfo.compMan.useCognito
    }
  },
  methods: {
    openItemsSelector (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    },
    async getEmployeeInfo (id) {
      if (id) {
        try {
          const result = await this.$API.employee.get({ id: id })
          if (result.status === 200) {
            return result.body.success[0]
          } else {
            return false
          }
        } catch (e) {
          const msg = e.data.error || 'Aconteceu um erro. Tente novamente.'
          this.$swal({
            type: 'error',
            title: 'Atenção',
            text: msg
          })
          this.$emit('close')
        }
      }
    },
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }

      const permkind = this.permissions.selected.kind
      let companies

      if (permkind === 'all') {
        companies = this.$store.state.common.companies.items
      } else if (permkind === 'group') {
        companies = this.companies.selected || []
      } else {
        companies = this.isFromEmployee
          ? [this.companyFromEmployee]
          : [this.user.compemployee.company[0]]
      }

      let userGroups = this.userGroups.selected || []

      if (companies.length === 0 && userGroups.length === 0 && permkind !== 'mine') {
        this.$swal({
          type: 'warning',
          title: 'Atenção',
          text: 'Deve ser escolhido pelo menos 1 local de trabalho ou 1 grupo'
        })
        return
      }

      if (!this.id && !this.password && !this.$store.state.userInfo.compMan.useCognito) {
        this.$swal({
          type: 'warning',
          title: 'Atenção',
          text: `${this.$ws('employee')} precisa de uma senha`
        })
        return
      }

      if (this.categories.selected.id === 'company') {
        userGroups = []
      } else {
        companies = []
      }

      this.loading = true
      const info = {}
      const data = this.user

      data.name = this.name
      data.email = this.email
      data.group = companies
      data.userGroup = userGroups
      data.roleGroup = this.permissions.selected
      data.sendReportsByEmail = false
      data.codigo = this.codigo
      if (this.isFromEmployee) data.compemployee = { id: this.employeeId }

      if (this.id) info.id = this.id
      if (this.password) data.password = this.password
      if (this.pg.selected.id !== 'same') data.appGestorRoleGroup = this.pg.selected

      try {
        await this.$API.user.save(info, data)
        await this.$swal({
          title: this.id ? `usuário editado!` : `Novo usuário!`,
          type: 'success',
          text: `O usuário foi ${this.id ? 'editado' : 'adicionado'} com successo`
        })
        await this.$swal({
          type: 'info',
          text: 'As alterações realizadas no usuário pode levar até um minuto para surtirem efeito.'
        })
        this.$emit('close')
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possível salvar o usuário'
        })
      }
      this.loading = false
    }
  },
  mixins: [useValidationsMixin({})],
  components: { RadioSlider },
  directives: { mask }
}
</script>

<style scoped lang="scss">
.wrapper-groups-details {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;

  .form-new {
    grid-row: 2;
    display: grid;
    grid-template-columns: .8fr 1fr;
    grid-column-gap: 20px;
    grid-template-areas:
      "name permissions"
      "email pg"
      "password codigo"
      "category selector"
      ". button";

    .name { grid-area: name }
    .email { grid-area: email }
    .permissions { grid-area: permissions }
    .pg { grid-area: pg }
    .password { grid-area: password }
    .codigo { grid-area: codigo }
    .items-selector { grid-area: selector }
    .items-slider {
      grid-area: category;
      align-self: center;
    }
    .button {
      margin-top: 20px;
      display: grid;
      grid-auto-flow: column;
      grid-area: button;
      justify-self: end;
      grid-column-gap: 2px;}
  }
  svg {
    animation: fade-in 2s ease;
  }
}
</style>
